var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-icon', {
    attrs: {
      "size": "xl",
      "icon": "eye"
    },
    on: {
      "click": _vm.showModal
    }
  }), _c('b-modal', {
    attrs: {
      "title": _vm.product.Name,
      "id": "quickViewModal",
      "size": "lg",
      "hide-footer": ""
    },
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "quick-view-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 d-flex"
  }, [_c('div', {
    staticClass: "col-md-3 d-flex flex-column"
  }, [_c('div', {
    staticClass: "thumbnail-images"
  }, _vm._l(_vm.imagesArr, function (thumb, index) {
    return _c('img', {
      key: index,
      staticClass: "img-thumbnail",
      class: {
        active: thumb === _vm.selectedImage
      },
      attrs: {
        "src": thumb,
        "alt": "Product Thumbnail"
      },
      on: {
        "click": function ($event) {
          return _vm.updateMainImage(thumb);
        }
      }
    });
  }), 0)]), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "main-image"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.selectedImage,
      "alt": "Product Image"
    }
  })])])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('h2', [_vm._v(_vm._s(_vm.product.Name))]), _vm.product.Availability ? _c('span', {
    class: ['badge', _vm.product.Availability.toLowerCase().trim() === 'out of stock' ? 'badge-danger' : 'badge-success', 'ml-2']
  }, [_vm._v(" " + _vm._s(_vm.product.Availability) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm.product.skuNo ? _c('b-icon-dot', {
    staticClass: "ml-2"
  }) : _vm._e(), _vm.product.skuNo ? _c('p', {
    staticClass: "mb-0 ml-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("quickView.skuNo")) + " " + _vm._s(_vm.product.skuNo) + " ")]) : _vm._e()], 1), _c('p', {
    staticClass: "mt-2 brand-info"
  }, [_c('strong', [_vm._v("Price: ")]), _c('span', {
    staticClass: "mr-1"
  }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + " " + _vm._s(Number(_vm.product["Deal Price"] ? _vm.product["Deal Price"] : _vm.product.Price).toFixed(2)) + " ")]), _vm.product['Deal Price'] ? _c('del', {}, [_vm._v(" " + _vm._s(_vm.currency.symbol) + " " + _vm._s(Number(_vm.product.Price).toFixed(2)) + " ")]) : _vm._e(), _vm.product['Discount'] || _vm.product['Discount(%)'] ? _c('span', {
    class: ['badge ml-2', _vm.product['Discount'] ? 'badge-danger' : '']
  }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + " " + _vm._s(_vm.product["Discount"] ? `${_vm.product["Discount"]} USD` + " Off" : _vm.product["Discount(%)"] + "% Off") + " ")]) : _vm._e()]), _c('hr'), _c('div', {
    staticClass: "brand-share d-flex align-items-center"
  }, [_c('div', {
    staticClass: "brand-info"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("quickView.brand")) + ": ")]), _vm._v(" " + _vm._s(_vm.product.Brand) + " ")])]), _c('p', {
    staticClass: "brand-info"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("description")) + ": ")]), _vm._v(_vm._s(_vm.product.Description) + " ")]), _c('hr'), _vm.product.Availability && _vm.product.Availability.toLowerCase().trim() === 'out of stock' ? _c('div', [_c('p', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("quickView.outOfStock")) + " ")])]) : _c('div', {
    staticClass: "d-flex add-button text-center mt-4"
  }, [_vm.$options.components['checkout-increment-decrement'] ? [_c('checkout-increment-decrement', {
    attrs: {
      "callCheckout": true,
      "cartItem": _vm.product
    }
  })] : _vm._e(), _c('div', {
    staticClass: "product-icon-circle pointer heart mt-2"
  }, [_vm.wishlistKey ? _c('b-icon', {
    attrs: {
      "size": "xl",
      "icon": "heart-fill"
    },
    on: {
      "click": function ($event) {
        return _vm.removeItem(_vm.product);
      }
    }
  }) : _c('b-icon', {
    attrs: {
      "size": "xl",
      "icon": "heart"
    },
    on: {
      "click": function ($event) {
        return _vm.addToWishlist(_vm.product);
      }
    }
  })], 1)], 2), _c('hr'), _c('div', {
    staticClass: "product-tags mt-3"
  }, [_vm.product.Category ? _c('strong', [_vm._v(_vm._s(_vm.$t("quickView.category")) + ": ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.product.Category) + " "), _c('br'), _vm.product.tags ? _c('strong', [_vm._v(_vm._s(_vm.$t("quickView.tags")) + ": ")]) : _vm._e(), _vm._l(_vm.product.tags, function (tag, index) {
    return _c('span', {
      key: tag,
      staticClass: "tag-badge mr-1"
    }, [_vm._v(" " + _vm._s(tag)), index < _vm.product.tags.length - 1 ? _c('span', [_vm._v(",")]) : _vm._e()]);
  })], 2)])])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }